export const getLanguage = (state) =>
  state.language.languageData ? state.language.languageData : null;
export const selectedLanguage = (state) =>
  state.language.selectedLanguage ? state.language.selectedLanguage : "en";
